import React from 'react'

import { Form, Col } from '_zari/core'

import { MesesContabilidadConstant } from 'constants/index'

const MesFormGroup = ({ mesSeleccionado, setMesSeleccionado }) => {
  // const currentMonth = React.useMemo(() => {
  //   return new Date().getMonth() + 1
  // }, [])

  const selectOpions = React.useMemo(() => {
    const salida = []
    for (let i = 0; i <= 12; i++) {
      const element = MesesContabilidadConstant.__array[i]
      salida.push(
        <option key={i} value={element.id}>
          {element.nombre}
        </option>
      )
    }

    return salida
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MES' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select value={mesSeleccionado} id='select-mes' onChange={e => setMesSeleccionado(e.target.value)}>
          {selectOpions}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesFormGroup)
